import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { theme } from '../utils/theme';

const HeroHeader = () => {
  const { t } = useTranslation('hero');
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleLoad = () => {
      // Small delay to ensure video is fully ready
      setTimeout(() => {
        setIsVideoLoaded(true);
      }, 100);
    };

    video.addEventListener('loadeddata', handleLoad);
    return () => video.removeEventListener('loadeddata', handleLoad);
  }, []);

  return (
    <section
      className={theme.section + ' relative bg-cover bg-center bg-no-repeat min-h-[100vh] bg-background-primary sm:mt-0 overflow-hidden'}
    >
      {/* Background image that shows while video loads */}
      <div 
        className="absolute inset-0 w-full h-full transition-opacity duration-[1500ms] ease-in-out"
        style={{
          backgroundImage: 'url(/hero/hero_image.jpg)',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          transform: 'scaleX(-1)',
          opacity: isVideoLoaded ? 0 : 1
        }}
      ></div>

      {/* Video element */}
      <video 
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover scale-x-[-1] transition-opacity duration-[2000ms] ease-in-out" 
        style={{ opacity: isVideoLoaded ? 1 : 0 }}
        autoPlay 
        muted 
        loop 
        playsInline
      >
        <source src="/hero/hero_video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      
      <div className="absolute inset-0 bg-gray-900/30 lg:bg-gradient-to-r lg:from-gray-900/35 lg:to-gray-900/25"></div>

      <div className="absolute bottom-0 left-0 w-full px-4 pb-8 sm:px-6 lg:px-8 pt-48 sm:pt-32">
        <div className="max-w-xl text-left mt-32 sm:mt-16">
          <h1 className={theme.text.display + ' text-white mt-16 sm:mt-0'}>
            {t('title')}
          </h1>
          <p className={theme.text.body + ' mt-4 max-w-lg text-white'}>
            {t('description')}
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link
              to="/login"
              className={theme.button.base + ' ' + theme.button.cta + ' ' + theme.button.sizes.lg}
            >
              {t('buttons.getStarted')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroHeader;